'use strict';

import angular from 'angular';
import Tooltip from 'tether-tooltip';

function saTooltip($timeout) {
  'ngInject';

  return {
    restrict: 'A',
    link: function ($scope, $element, $attr) {
      const TOOLTIP_DELAY = 500;

      const tooltip = new Tooltip({
        target: $element[0],
        position: $attr.position,
        content: $attr.saTooltip,
        openOn: '',
        constrainToWindow: true,
        constrainToScrollParent: false,
        classes: 'Tooltip tooltip-theme-twipsy',
        tetherOptions: {
          offset: $attr.offset
        }
      });

      // Delay tooltip showing
      $timeout(() => {
        var open = true;
        $element.on('mouseover', () => {
          open = true;
          $timeout(() => {
            if (open) {
              tooltip.open();
            }
          }, TOOLTIP_DELAY);
        });

        $element.on('mouseleave', () => {
          tooltip.close();
          open = false;
        });

        $element.on('click', () => {
          tooltip.open();
        });
      });

      $element.on('$destroy', () => {
        tooltip.destroy();
      });
    }
  };
}

export default angular
  .module('directives.tooltip', [])
  .directive('saTooltip', saTooltip)
  .name;



// WEBPACK FOOTER //
// ./app/src/directives/tooltip.directive.js